import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import EntryDisclaimer from "@/components/EntryDisclaimer";
import MobileBar from "@/components/MobileBar";
import Home from "@/pages/Home";
import PracticeAreas from "@/pages/PracticeAreas";
import Insights from "@/pages/Insights";
import InsightArticle from "@/pages/InsightArticle";
import Panel from "@/pages/Panel";
import Profile from "@/pages/Profile";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import Admin from "@/pages/Admin";
import Track from "@/pages/Track";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Shell = () => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      <EntryDisclaimer />
      {!isAdmin && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/practice-areas" element={<PracticeAreas />} />
          <Route path="/legal-insights" element={<Insights />} />
          <Route path="/legal-insights/:slug" element={<InsightArticle />} />
          <Route path="/advocate-panel" element={<Panel />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/disclaimer" element={<Legal page="disclaimer" />} />
          <Route path="/privacy-policy" element={<Legal page="privacy" />} />
          <Route path="/terms-of-use" element={<Legal page="terms" />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      {!isAdmin && (
        <>
          <Footer />
          <MobileBar />
        </>
      )}
    </>
  );
};

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Shell />
      <Toaster position="top-center" />
    </BrowserRouter>
  );
}

export default App;
